<template>
  <v-main>
    <tool-bar pageTitle="Plexus"> </tool-bar>

    <v-container v-if="!handleBlur" fluid class="pa-0 plexus-layout">
      <side-menu />
      <div class="plexus-content">
        <v-tabs v-model="tab" background-color="black" height="25">
          <v-tab v-for="(item, index) in tabs" class="font-weight-light" :key="index">
            {{ item.title }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="tabs-content">
          <v-tab-item>
            <grid-view />
          </v-tab-item>
            <!-- <v-tab-item>
              <tile-view :tradeTableItems="tradeTableItems" :headers="headers" :view-tabs="viewTabs"
                :main-tabs="mainTabs" :trades="trades" /></v-tab-item>-->
        </v-tabs-items>
      </div>
    </v-container>
    <div v-else>
      <img src="../assets/blur_imgs/blur5.png" :alt="$t('extras.blurredImageLockedAlt')">
    </div>
    <!--left-->

    <!-- TODO-->
  </v-main>
</template>
<script>
import { mapStores } from "pinia";
import ToolBar from "../components/layout/ToolBar.vue";
import { useCoreStore } from "@/store/coreStore";
import SideMenu from "@/components/common/SideMenu.vue";
import TileView from "@/components/plexus/TileView.vue";
import GridView from "@/components/plexus/GridView.vue";
export default {
  components: {
    ToolBar,
    SideMenu,
    TileView,
    GridView
  },
  data() {
    return {
      tab: 0,
      TileTabs: [
        { title: "G10", value: "g10" },
        { title: "My Tabs 2", value: "my_tabs_2" },
        { title: "My Tabs 3", value: "my_tabs_3" },
        { title: "+", value: "add" },
      ],
      tradeTableItems: [
        {
          ref: "C1254153756982",
          product: "FORWARD",
          channel: "Pulse",
          ccyPair: "USD-ZAR",
          side: "BUY",
          base: "4,099,000",
          term: "5,328,700",
          spot: "1.35159",
          point: "0.13587",
        },
        {
          ref: "C1254153756991",
          product: "SPOT",
          channel: "Bloomberg",
          ccyPair: "EUR-USD",
          side: "SELL",
          base: "2,150,000",
          term: "2,147,800",
          spot: "1.08720",
          point: "-0.00210",
        },
        {
          ref: "C1254153757004",
          product: "SWAP",
          channel: "FXGO",
          ccyPair: "GBP-USD",
          side: "BUY",
          base: "3,500,000",
          term: "3,612,450",
          spot: "1.27340",
          point: "0.00450",
        },
        {
          ref: "C1254153757018",
          product: "FORWARD",
          channel: "Pulse",
          ccyPair: "USD-JPY",
          side: "SELL",
          base: "6,200,000",
          term: "6,310,500",
          spot: "149.250",
          point: "0.320",
        },
        {
          ref: "C1254153757026",
          product: "SPOT",
          channel: "FXGO",
          ccyPair: "AUD-USD",
          side: "BUY",
          base: "1,750,000",
          term: "1,749,200",
          spot: "0.66210",
          point: "-0.00080",
        },
        {
          ref: "C1254153757033",
          product: "FORWARD",
          channel: "Pulse",
          ccyPair: "USD-CAD",
          side: "SELL",
          base: "5,000,000",
          term: "5,045,300",
          spot: "1.36200",
          point: "0.01120",
        },
        {
          ref: "C1254153757040",
          product: "SWAP",
          channel: "Bloomberg",
          ccyPair: "EUR-GBP",
          side: "BUY",
          base: "2,800,000",
          term: "2,799,100",
          spot: "0.85340",
          point: "-0.00130",
        },
        {
          ref: "C1254153757049",
          product: "FORWARD",
          channel: "FXGO",
          ccyPair: "USD-CHF",
          side: "SELL",
          base: "3,200,000",
          term: "3,215,600",
          spot: "0.89120",
          point: "0.00210",
        },
        {
          ref: "C1254153757055",
          product: "SPOT",
          channel: "Pulse",
          ccyPair: "NZD-USD",
          side: "BUY",
          base: "1,200,000",
          term: "1,199,400",
          spot: "0.59870",
          point: "-0.00060",
        },
        {
          ref: "C1254153757062",
          product: "FORWARD",
          channel: "Bloomberg",
          ccyPair: "USD-MXN",
          side: "SELL",
          base: "7,500,000",
          term: "7,620,800",
          spot: "17.0420",
          point: "0.18050",
        },
      ],
      headers: [
        { text: "Citi Trade Ref", value: "ref" },
        { text: "Product", value: "product" },
        { text: "Channels", value: "channel" },
        { text: "CCY Pair", value: "ccyPair" },
        { text: "Buy/Sell", value: "side" },
        { text: "Base", value: "base" },
        { text: "Term", value: "term" },
        { text: "Spot", value: "spot" },
        { text: "Point", value: "point" },
      ],
      mainTabs: [
        "Executed FX",
        "FX Orders",
        "Cash Ladder",
        "Execution Manager",
        "Infinity Cable",
        "Historical Blotter",
      ],
      viewTabs: ["View", "My Trades", "Today's Trades"],
      trades: [
        {
          pair: "EUR/USD",
          side: "SELL",
          price: "1.213355",
          date: "18 May 20",
          amount: "1,000,000",
        },
        {
          pair: "EUR/CHF",
          side: "BUY",
          price: "1.07646",
          date: "18 May 20",
          amount: "1,000,000",
        },
        {
          pair: "USD/JPY",
          side: "SELL",
          price: "1.03947",
          date: "18 May 20",
          amount: "1,000,000",
        },
        {
          pair: "EUR/JPY",
          side: "BUY",
          price: "126154",
          date: "18 May 20",
          amount: "1,000,000",
        },
        {
          pair: "GBP/USD",
          side: "SELL",
          price: "1.36117",
          date: "18 May 20",
          amount: "1,000,000",
        },
        {
          pair: "EUR/GBP",
          side: "BUY",
          price: "0.89147",
          date: "18 May 20",
          amount: "1,000,000",
        },
        {
          pair: "AUD/USD",
          side: "BUY",
          price: "0.77140",
          date: "18 May 20",
          amount: "1,000,000",
        },
        {
          pair: "NZD/USD",
          side: "Sell",
          price: "0.71246",
          date: "18 May 20",
          amount: "1,000,000",
        },
      ],
      date: new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(new Date()),
    };
  },
  name: "PLEXUS",
  methods: {
    formatColor(trade) {
      return trade.side.toUpperCase() === "SELL" ? "sell" : "buy";
    },
    formatColorInverse(trade) {
      return trade.side.toUpperCase() === "BUY" ? "sell" : "buy";
    },
  },
  computed: {
    ...mapStores(useCoreStore),
    tabs() {
      return [{ title: this.$t('plexus.tradingTab') }];
    },
    handleBlur() {
      return this.coreStore.evaluateBlur(this.$options.name)
    },
  },
};
</script>
<style>

.border-trades {
  border: 1px solid white;
  text-align: center;
  width: 59px;
  padding: 0.2rem 0.6rem;
}

.trades-pair>div {
  min-height: 0;
}

.no-border .v-input__slot fieldset {
  border: none !important;
}

.v-navigation-drawer {
  background-color: var(--surface) !important;
}

.theme--dark.v-tabs-items.tabs-content {
    background-color: transparent;
}
.amount-size {
  display: flex;
  font-size: 1.7rem;
  justify-content: center;
}

.buy {
  color: #e55353;
}

.sell {
  color: #26c281;
}

.trade-price {
  font-size: 4.5rem;
  font-weight: 700;
}

.small-input {
  width: 130px;
}

::v-deep .v-main__wrap {
  height: 100%;
}

.plexus-layout{
  display: flex;
  height: 100%;
  align-items: flex-start;
}


.plexus-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.right-content-col {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tabs-content {
  flex: 1 !important;
  min-height: 0;
}

.tabs-content .v-window__container {
  height: 100%;
}

.tabs-content .v-window-item {
  height: 100%;
}

.trade-form-grid {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 0 16px;
  align-items: center;
}

.form-trade-grid .titles {
  grid-column: 1;
}

.form-trade-grid .fields {
  grid-column: 2;
}

.form-trade-reason {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-grow: 1;
}

.right-placeholder.v-input {
  height: 22px !important;
  min-height: 22px !important;
  font-size: 10px !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 2px;
  font-weight: 400 !important;
  color: white !important;
}

.right-placeholder .v-input__control {
  height: 22px !important;
  min-height: 22px !important;
  color: white !important;
}

.right-placeholder .v-input__slot {
  height: 22px !important;
  min-height: 22px !important;
  margin: 0 !important;
  padding: 0 4px !important;
  color: white !important;
}

.right-placeholder .v-select__slot,
.right-placeholder .v-select__selections {
  height: 22px !important;
  min-height: 22px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  color: white !important;
}

.right-placeholder input {
  height: 22px !important;
  max-height: 22px !important;
  padding: 0 !important;
  font-size: 10px !important;
  line-height: 22px !important;
  color: white !important;
  text-align: right !important;
}

.right-placeholder .v-select__selection,
.right-placeholder .v-select__selection--placeholder {
  font-size: 10px !important;
  line-height: 22px !important;
  margin: 0 !important;
}

.right-placeholder .v-input__append-inner,
.right-placeholder .v-input__prepend-inner {
  margin-top: 0 !important;
  height: 22px !important;
  align-self: center !important;
}

.right-placeholder .v-icon {
  font-size: 14px !important;
}

.right-placeholder .v-text-field__details,
.right-placeholder .v-messages {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  margin: 0 !important;
}

::v-deep .v-text-field input {
  padding: 0 !important;
}

::v-deep .v-input__control {
  height: 30px !important;
}
::v-deep
  .v-input
  .v-input__control
  .v-input__slot
  fieldset
  .v-select__slot
  .v-select__selections {
  text-align: right !important;
  max-height: 30px !important;
  padding: 0 !important;
}

::v-deep .right-placeholder .v-text-field__details {
  display: none !important;
}

::v-deep .v-data-table th {
  font-size: 0.5rem !important;
  white-space: nowrap !important;
  padding: 0.2rem 1rem 0.5rem 0rem;
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  height: 30px !important;
  font-size: 0.5rem !important;
}


::v-deep .v-text-field__details {
  display: none !important;
}
</style>
